(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["solmika-emotional-entry"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sectionRoot =
      document.currentScript && document.currentScript.closest
        ? document.currentScript.closest('.shopify-section')
        : null;
    const panel = sectionRoot
      ? sectionRoot.querySelector('[data-solmika-emotional-panel]')
      : document.querySelector('[data-solmika-emotional-panel]');

    if (!panel) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      panel.classList.add('is-visible');
      return;
    }

    if (!('IntersectionObserver' in window)) {
      panel.classList.add('is-visible');
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          panel.classList.add('is-visible');
          observer.unobserve(panel);
        });
      },
      {
        threshold: 0.2,
        rootMargin: '0px 0px -6% 0px',
      }
    );

    observer.observe(panel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solmika-feeling-selector"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sectionRoot =
      document.currentScript && document.currentScript.closest
        ? document.currentScript.closest('.shopify-section')
        : null;
    const scope = sectionRoot || document;

    scope.querySelectorAll('[data-solmika-feeling-toggle]').forEach(function (btn) {
      const card = btn.closest('.solmika-feeling-card');
      if (!card) return;
      const panel = card.querySelector('[data-solmika-feeling-panel]');
      if (!panel) return;

      btn.addEventListener('click', function () {
        const open = btn.getAttribute('aria-expanded') === 'true';

        scope.querySelectorAll('[data-solmika-feeling-toggle]').forEach(function (otherBtn) {
          if (otherBtn === btn) return;
          const otherCard = otherBtn.closest('.solmika-feeling-card');
          const otherPanel = otherCard && otherCard.querySelector('[data-solmika-feeling-panel]');
          otherBtn.setAttribute('aria-expanded', 'false');
          if (otherPanel) otherPanel.setAttribute('hidden', '');
          if (otherCard) otherCard.classList.remove('is-open');
        });

        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (open) {
          panel.setAttribute('hidden', '');
          card.classList.remove('is-open');
        } else {
          panel.removeAttribute('hidden');
          card.classList.add('is-open');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solmika-gift-concierge"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.querySelector('[data-solmika-gift-concierge-form]');
    if (!form) return;

    form.addEventListener('submit', function () {
      var shoppingFor = form.querySelector('[data-solmika-gift-concierge-shopping-for]');
      var occasion = form.querySelector('[data-solmika-gift-concierge-occasion]');
      var budget = form.querySelector('[data-solmika-gift-concierge-budget]');
      var message = form.querySelector('[data-solmika-gift-concierge-message]');
      var nameField = form.querySelector('[name="contact[name]"]');
      var emailField = form.querySelector('[name="contact[email]"]');

      if (!message) return;

      var subjectLine = form.getAttribute('data-email-subject') || 'New Gift Concierge Request';
      var formSource = form.getAttribute('data-form-source') || 'Gift Concierge';
      var formSourceId = form.getAttribute('data-form-source-id') || 'gift-concierge';
      var userMessage = message.value || '(No message provided)';

      var lines = [
        subjectLine,
        '',
        'Form Source: ' + formSource,
        'Form-Source-ID: ' + formSourceId,
        '',
        'Name: ' + (nameField && nameField.value ? nameField.value : ''),
        'Email: ' + (emailField && emailField.value ? emailField.value : ''),
        'Shopping For: ' + (shoppingFor && shoppingFor.value ? shoppingFor.value : 'Not specified'),
        'Occasion: ' + (occasion && occasion.value ? occasion.value : 'Not specified'),
        'Budget: ' + (budget && budget.value ? budget.value : 'Not specified'),
        '',
        'Message:',
        userMessage
      ];

      message.value = lines.join('\n');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solmika-header"]) return;
  try {
    
  (function () {
    const header = document.querySelector("[data-solmika-header]");
    const burger = document.querySelector("[data-solmika-burger]");

    function normalizeNavPath(path) {
      if (!path) return "/";
      var cleaned = path.split("?")[0].split("#")[0];
      if (cleaned.length > 1 && cleaned.endsWith("/")) {
        cleaned = cleaned.slice(0, -1);
      }
      return cleaned || "/";
    }

    function setNavLinkActive(link, active) {
      if (!link) return;
      link.classList.toggle("solmika-header__menu-link--active", active);
      if (active) {
        link.setAttribute("aria-current", "page");
      } else {
        link.removeAttribute("aria-current");
      }
    }

    function syncHeaderNavActive() {
      if (!header) return;

      var currentPath = normalizeNavPath(window.location.pathname);
      var currentHash = window.location.hash || "";
      var pageHandle = header.getAttribute("data-page-handle") || "";
      var isOccasionCollection = header.getAttribute("data-occasion-collection") === "true";
      var navLinks = header.querySelectorAll(".solmika-header__menu-link[href]");

      navLinks.forEach(function (link) {
        var href = link.getAttribute("href");
        if (!href) {
          setNavLinkActive(link, false);
          return;
        }

        var url;
        try {
          url = new URL(href, window.location.origin);
        } catch (error) {
          setNavLinkActive(link, false);
          return;
        }

        var linkPath = normalizeNavPath(url.pathname);
        var linkHash = url.hash || "";
        var isOccasionLink = link.hasAttribute("data-solmika-occasion-link");
        var isActive = false;

        if (isOccasionLink) {
          isActive =
            pageHandle === "shop-by-occasion" ||
            pageHandle === "gifts-for-mum" ||
            pageHandle === "christmas-gift-boxes" ||
            pageHandle === "birthday-gift-box" ||
            pageHandle === "gifts-for-someone-going-through-a-hard-time" ||
            isOccasionCollection;
        } else if (linkHash) {
          isActive = linkPath === currentPath && linkHash === currentHash;
        } else if (currentPath === "/") {
          isActive = linkPath === "/" && currentHash === "";
        } else {
          isActive = linkPath === currentPath && currentHash === "";
        }

        setNavLinkActive(link, isActive);
      });
    }

    syncHeaderNavActive();
    const panel = document.querySelector("[data-solmika-mobile-menu]");
    const occasionItem = document.querySelector("[data-solmika-occasion-item]");
    const occasionPanel = document.querySelector("[data-solmika-occasion-panel]");
    const occasionToggle = document.querySelector("[data-solmika-occasion-toggle]");
    const occasionLink = document.querySelector("[data-solmika-occasion-link]");
    const mobileOccasionTrigger = document.querySelector("[data-solmika-occasion-mobile-trigger]");
    const mobileOccasionPanel = document.querySelector("[data-solmika-occasion-mobile-panel]");
    const occasionVisualWrapper = document.querySelector("[data-solmika-occasion-visual]");
    const occasionVisualImage = occasionVisualWrapper ? occasionVisualWrapper.querySelector("img") : null;
    const occasionHoverLinks = Array.from(document.querySelectorAll("[data-solmika-occasion-hover-src]"));
    const originalVisualSrc = occasionVisualImage ? occasionVisualImage.getAttribute("src") : "";
    const originalVisualAlt = occasionVisualImage ? occasionVisualImage.getAttribute("alt") : "";
    const originalVisualSrcset = occasionVisualImage ? occasionVisualImage.getAttribute("srcset") : "";
    const originalVisualSizes = occasionVisualImage ? occasionVisualImage.getAttribute("sizes") : "";
    let occasionPinned = false;
    let occasionHoverCloseTimer = null;

    function cancelOccasionHoverClose() {
      if (occasionHoverCloseTimer) {
        clearTimeout(occasionHoverCloseTimer);
        occasionHoverCloseTimer = null;
      }
    }

    function scheduleOccasionHoverClose() {
      cancelOccasionHoverClose();
      occasionHoverCloseTimer = setTimeout(function () {
        if (!occasionPinned) {
          setDesktopOccasionOpen(false);
        }
      }, 120);
    }

    function openOccasionFromHover() {
      cancelOccasionHoverClose();
      setDesktopOccasionOpen(true);
    }

    function setMobileMenuOpen(open) {
      if (!burger || !panel) return;
      burger.setAttribute("aria-expanded", open ? "true" : "false");
      if (open) {
        panel.removeAttribute("hidden");
      } else {
        panel.setAttribute("hidden", "");
        setMobileOccasionOpen(false);
      }
    }

    function setDesktopOccasionOpen(open, force) {
      if (!occasionPanel || !occasionToggle || !occasionItem) return;
      if (!open && occasionPinned && !force) return;
      if (!open) occasionPinned = false;

      occasionToggle.setAttribute("aria-expanded", open ? "true" : "false");
      occasionItem.classList.toggle("is-open", open);
      if (open) {
        occasionPanel.removeAttribute("hidden");
      } else {
        occasionPanel.setAttribute("hidden", "");
        resetOccasionVisual();
      }
    }

    function toggleDesktopOccasionMenu(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      const isOpen = occasionToggle.getAttribute("aria-expanded") === "true";
      if (isOpen) {
        setDesktopOccasionOpen(false, true);
        return;
      }
      occasionPinned = true;
      setDesktopOccasionOpen(true);
    }

    function setMobileOccasionOpen(open) {
      if (!mobileOccasionTrigger || !mobileOccasionPanel) return;
      mobileOccasionTrigger.setAttribute("aria-expanded", open ? "true" : "false");
      mobileOccasionTrigger.closest(".solmika-header__mobile-item--occasion")?.classList.toggle("is-open", open);
      if (open) {
        mobileOccasionPanel.removeAttribute("hidden");
      } else {
        mobileOccasionPanel.setAttribute("hidden", "");
      }
    }

    function setOccasionVisualFromLink(linkEl) {
      if (!occasionVisualImage || !linkEl) return;
      const src = linkEl.getAttribute("data-solmika-occasion-hover-src");
      if (!src) return;
      const alt = linkEl.getAttribute("data-solmika-occasion-hover-alt") || originalVisualAlt;
      // Remove responsive candidates from the default editorial image so the hovered src is honored.
      occasionVisualImage.removeAttribute("srcset");
      occasionVisualImage.removeAttribute("sizes");
      occasionVisualImage.setAttribute("src", src);
      occasionVisualImage.setAttribute("alt", alt);
    }

    function resetOccasionVisual() {
      if (!occasionVisualImage || !originalVisualSrc) return;
      occasionVisualImage.setAttribute("src", originalVisualSrc);
      occasionVisualImage.setAttribute("alt", originalVisualAlt);
      if (originalVisualSrcset) {
        occasionVisualImage.setAttribute("srcset", originalVisualSrcset);
      }
      if (originalVisualSizes) {
        occasionVisualImage.setAttribute("sizes", originalVisualSizes);
      }
    }

    if (burger && panel) {
      burger.addEventListener("click", function () {
        const isOpen = burger.getAttribute("aria-expanded") === "true";
        setMobileMenuOpen(!isOpen);
      });
    }

    if (occasionItem && occasionPanel && occasionToggle) {
      occasionToggle.addEventListener("click", toggleDesktopOccasionMenu);

      occasionPanel.addEventListener("click", function (event) {
        event.stopPropagation();
      });

      occasionItem.addEventListener("mouseenter", openOccasionFromHover);
      occasionItem.addEventListener("mouseleave", scheduleOccasionHoverClose);
      occasionPanel.addEventListener("mouseenter", openOccasionFromHover);
      occasionPanel.addEventListener("mouseleave", scheduleOccasionHoverClose);

      occasionItem.addEventListener("focusin", function (event) {
        if (event.target === occasionToggle) {
          occasionPinned = true;
          setDesktopOccasionOpen(true);
        }
      });

      if (occasionHoverLinks.length > 0) {
        occasionHoverLinks.forEach(function (link) {
          link.addEventListener("mouseenter", function () {
            setOccasionVisualFromLink(link);
          });
          link.addEventListener("focus", function () {
            setOccasionVisualFromLink(link);
          });
        });

        occasionPanel.addEventListener("mouseleave", function () {
          resetOccasionVisual();
        });
      }
    }

    if (mobileOccasionTrigger && mobileOccasionPanel) {
      mobileOccasionTrigger.addEventListener("click", function () {
        const isOpen = mobileOccasionTrigger.getAttribute("aria-expanded") === "true";
        setMobileOccasionOpen(!isOpen);
      });
    }

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        setDesktopOccasionOpen(false, true);
        setMobileOccasionOpen(false);
      }
    });

    document.addEventListener("click", function (event) {
      if (!header) return;
      if (!header.contains(event.target)) {
        setDesktopOccasionOpen(false, true);
      }
    });

    // ─── Hover-image diagnostics overlay (?solmika-debug=hover) ───
    try {
      var debugParam = new URLSearchParams(window.location.search).get("solmika-debug");
      if (debugParam === "hover") {
        var overlay = document.createElement("div");
        overlay.setAttribute("data-solmika-debug-overlay", "");
        overlay.style.cssText =
          "position:fixed;bottom:12px;right:12px;z-index:99999;max-width:380px;" +
          "background:rgba(20,20,20,0.92);color:#fff;font:12px/1.4 ui-monospace,monospace;" +
          "padding:10px 12px;border-radius:8px;box-shadow:0 6px 24px rgba(0,0,0,0.4);" +
          "white-space:pre-wrap;pointer-events:none;";
        document.body.appendChild(overlay);
        var lastEvent = "(none)";
        function render() {
          var imgSrc = occasionVisualImage ? occasionVisualImage.getAttribute("src") : "(no img)";
          var imgSrcset = occasionVisualImage ? (occasionVisualImage.getAttribute("srcset") || "(none)") : "(no img)";
          var truncate = function (s) { return s && s.length > 60 ? s.slice(0, 60) + "…" : s; };
          overlay.textContent =
            "Solmika hover debug\n" +
            "─────────────────\n" +
            "wrapper: " + (occasionVisualWrapper ? "FOUND" : "MISSING [data-solmika-occasion-visual]") + "\n" +
            "img inside wrapper: " + (occasionVisualImage ? "FOUND" : "MISSING") + "\n" +
            "hover links found: " + occasionHoverLinks.length + "\n" +
            "panel: " + (occasionPanel ? "FOUND" : "MISSING") + "\n" +
            "current src: " + truncate(imgSrc) + "\n" +
            "current srcset: " + truncate(imgSrcset) + "\n" +
            "last event: " + lastEvent;
        }
        render();
        if (occasionHoverLinks.length > 0) {
          occasionHoverLinks.forEach(function (link) {
            link.addEventListener("mouseenter", function () {
              lastEvent = "mouseenter → " + (link.getAttribute("data-solmika-occasion-hover-src") || "(no src)");
              setTimeout(render, 0);
            });
          });
        }
        if (occasionPanel) {
          occasionPanel.addEventListener("mouseleave", function () {
            lastEvent = "mouseleave → reset";
            setTimeout(render, 0);
          });
        }
        // Also re-render periodically so user can see the live src after a hover.
        setInterval(render, 500);
      }
    } catch (err) {
      // noop
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solmika-main-product"]) return;
  try {
    
  (function () {
    const form = document.querySelector(".solmika-product__form");
    if (!form) return;

    const variantInput = form.querySelector("[data-solmika-variant-id]");
    const selects = Array.from(form.querySelectorAll("[data-solmika-variant-select]"));
    const submit = form.querySelector("[data-solmika-add]");

    const variantsJson = form.querySelector("[data-solmika-variants]");
    const labelsJson = form.querySelector("[data-solmika-variant-labels]");
    if (!variantInput || !variantsJson || selects.length === 0) return;

    let variants;
    let labels;
    try {
      variants = JSON.parse(variantsJson.textContent);
      labels = labelsJson ? JSON.parse(labelsJson.textContent) : {};
    } catch (e) {
      return;
    }

    function findVariant() {
      const selected = selects.map(function (s) {
        return s.value;
      });
      return variants.find(function (v) {
        var o1 = selected[0] == null || selected[0] === v.option1;
        var o2 = selected[1] == null || selected[1] === v.option2;
        var o3 = selected[2] == null || selected[2] === v.option3;
        return o1 && o2 && o3;
      });
    }

    function sync() {
      const v = findVariant();
      if (!v) {
        variantInput.value = "";
        if (submit) {
          submit.disabled = true;
          submit.textContent = labels.unavailable || "Unavailable";
        }
        return;
      }

      variantInput.value = v.id;

      if (submit) {
        if (v.available) {
          submit.disabled = false;
          submit.textContent = labels.available || "Add to bag";
        } else {
          submit.disabled = true;
          submit.textContent = labels.sold_out || "Sold out";
        }
      }
    }

    selects.forEach(function (s) {
      s.addEventListener("change", sync);
    });
    sync();
  })();

  } catch(e) { console.error(e); }
})();
})();
